import { useDispatch, useSelector } from "react-redux";
import OrderDetailsComponent from "./OrderDetailsComponent";
import { AppDispatch, RootState } from "../redux/AppStore";
import { useEffect, useState } from "react";
import { GetThemeCssThunk } from "../redux/slice/TrackingSlice";
export default function InitialComponent () {
    return (
        <>
        <OrderDetailsComponent/>
        <SiteTheme />
        <div className="RowFull_width">
            <div className="container cntParcel_width">
                <div className="row cntParcel_center">
                    <div className="containerParcel">
                        <img src="/img/Icon_parcel2.svg" alt="Parcel Icon" className="iconParcel" />
                        <h1 className="Htag_Parcel">Track Your Parcel with Ease!</h1>
                        <p className="Ptag_Parcel">Simply enter your tracking number to get real-time updates on your parcel’s journey.</p>
                    </div>
                </div>
            </div>
        </div></>

    );
}
const SiteTheme: React.FC<any> = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [siteAddress, setSiteAddress] = useState<string>('');
    useEffect(() => {
        setSiteAddress(window.location.href);
    }, []);
    useEffect(() => {
         dispatch(
            GetThemeCssThunk({
                endpoint: "getclientcss",
                domain: window.location.href,
            }))
    }, []);
    const css = useSelector((state: RootState) => state.tracking.themecss);
    return (
        <>
         { css && css['tracking_domain'] && siteAddress.includes(css['tracking_domain']) &&
            <link rel="stylesheet" href={css['tracking_root_path']} />}
        </>
    );
}
